<template>
  <div>
    <van-nav-bar
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="form-div">
      <van-field v-model="telephone" label="当前手机号" readonly input-align="right"/>
      <van-field v-model="userNumber" readonly input-align="right">
        <template #label>
          用户编号<span class="required-span">*</span>
        </template>
      </van-field>
      <van-field type="textarea" readonly input-align="right" autosize>
        <template #label>
          详细地址<span class="required-span">*</span>
        </template>
        <template #input>
          <div class="correct-address-div">
            若信息有误，您可以
            <span class="correct-address-span" @click="toCorrectAddress()">申报更正地址</span>
          </div>
          <textarea v-model="detailedAddress" readonly></textarea>
        </template>
      </van-field>
      <van-field v-model="contact" :readonly="contact !== ''" input-align="right">
        <template #label>
          联系人<span class="required-span">*</span>
        </template>
      </van-field>
      <van-field v-model="label" placeholder="请输入标签" input-align="right" maxlength="10">
        <template #label>
          标签<span class="required-span">*</span>
        </template>
      </van-field>
      <div class="button-div">
        <div class="confirm-div">请确认详细地址无误后再绑定</div>
        <van-button color="#CE0022" class="login-button button-shadow" @click="confirmBind()">确认</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { newConfirmBindUserGas } from '../../api/accountNumberManagement'
import { getUserInfo } from '../../api/login'

export default {
  name: 'VerifyAddress',
  data () {
    return {
      telephone: '', // 当前手机号
      userNumber: '', // 用户编号
      detailedAddress: '', // 详细地址
      contact: '', // 联系人
      meterType: '', // 表型
      timer: null,
      label: '' // 标签
    }
  },
  mounted () {
    this.telephone = JSON.parse(window.localStorage.userInfo).mobile
    this.userNumber = this.$route.params.number
    this.detailedAddress = this.$route.params.data
    this.contact = JSON.parse(window.localStorage.userInfo).contacts ? JSON.parse(window.localStorage.userInfo).contacts : ''
    this.meterType = this.$route.params.meterType
  },
  methods: {
    // 返回
    onClickLeft () {
      this.$router.go(-1)
    },

    // 申报更正地址
    toCorrectAddress () {
      this.$router.push({
        name: 'CorrectAddress',
        params: {
          userNumber: this.userNumber,
          detailedAddress: this.detailedAddress
        }
      })
    },
    // 确认绑定燃气号
    confirmBind () {
      const that = this
      const addr = that.detailedAddress
      const number = that.userNumber
      if (!addr) {
        that.$toast('请确认地址')
      } else if (!number) {
        that.$toast('请确认用户编号')
      } else if (!that.contact) {
        that.$toast('请确认联系人')
      } else if (!that.label) {
        that.$toast('请确认标签')
      } else {
        that.$toast.loading({
          message: '提交中...',
          forbidClick: true,
          duration: 0
        })
        const params = {
          userId: JSON.parse(window.localStorage.userInfo).id,
          userCode: that.userNumber,
          contacts: that.contact,
          label: that.label,
          meterType: that.$route.params.meterType,
          address: addr
        }
        newConfirmBindUserGas(params).then(res => {
          if (res.data.success) {
            that.getInfo()
            that.$toast.success(res.data.message)
            // 清除延迟执行
            clearTimeout(that.timer)
            // 设置延迟执行,这里设置延迟两秒执行
            that.timer = setTimeout(() => {
              that.$router.go(-2)
            }, 2000)
          } else {
            that.$toast.fail(res.data.message)
          }
        }).catch(() => {
          that.$toast.fail('绑定燃气号失败')
        })
      }
    },

    // 根据userId获取用户信息
    getInfo () {
      const params = JSON.parse(window.localStorage.userInfo).id
      getUserInfo(params).then(res => {
        if (res.data.success) {
          window.localStorage.userInfo = JSON.stringify(res.data.rows[0])
        }
      }).catch(() => {
      })
    }
  }
}
</script>

<style scoped>
  .van-cell {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    padding: 12px 0;
    border-bottom: 1px solid rgba(16, 12, 13, 0.0784313725490196);
  }

  /deep/ .van-field__label {
    color: #62667A;
  }

  /deep/ .van-field__control {
    color: #27282E;
  }

  .form-div {
    padding: 0 4%;
  }

  .required-span {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #FF7825;
    margin-left: 1px;
  }

  .login-button {
    width: 100%;
    height: 50px;
    border-radius: 8px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    margin-top: 12px;
  }

  .button-shadow {
    box-shadow: 0px 6px 12px rgba(206, 0, 34, 0.3);
  }

  .button-div {
    width: 92%;
    margin-left: 4%;
    margin-top: 60%;
  }

  /deep/ .van-field__control--custom {
    flex-direction: column;
    align-items: flex-end;
  }

  .correct-address-div {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }

  .correct-address-span {
    color: #CE0022;
  }

  textarea {
    text-align: right;
    border: none;
    width: 100%;
    font-size: 17px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 23px;
    color: #27282E;
  }

  .confirm-div {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
    text-align: center;
  }
</style>
